import React, { useEffect } from 'react';

import { ReceivePacketCallback } from '../../../types';
import { useDownloadCafSDK } from './useDownloadCafSDK';
import { useOnCafError } from './useOnCafError';
import { useRequestCafPacket } from './useRequestCafPacket';

import * as Types from '../types';

export const useCafIntegration = ({
    sdk,
    enable,
    sdkUrl,
    license,
    transactionID,
    useTransparentPopup,
    onConnect,
    setShowOverlay,
    receivePacket
}: {
    sdk: Types.CAFSdkInstance | null;
    enable: boolean;
    sdkUrl: string;
    license: any;
    transactionID: string | null;
    useTransparentPopup: boolean;
    onConnect: CallableFunction;
    setShowOverlay: React.Dispatch<React.SetStateAction<boolean>>;
    receivePacket: ReceivePacketCallback;
}) => {
    const downloadCafSDK = useDownloadCafSDK({ sdkUrl });
    const onError = useOnCafError({ transactionID, setShowOverlay, useTransparentPopup });
    const requestCafPacket = useRequestCafPacket({
        sdk,
        license,
        transactionID,
        onError,
        receivePacket
    });

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        onConnect();
    }, [sdk, enable, onConnect]);

    return { requestCafPacket, downloadCafSDK };
};
